var _g, _path, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 101,
    viewBox: "0 0 103 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_689_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7583 51.684V58.1752H73.0388C73.0388 58.1752 75.6328 58.9765 75.6328 61.7508C75.6328 64.5251 73.0388 65.0954 73.0388 65.0954H68.7231L63.6878 71.5274L72.2579 80.0543H82.0273L73.4643 71.5274C73.4643 71.5274 82.0273 69.5427 82.0273 61.7508C82.0273 53.959 75.2653 51.684 73.0388 51.684H62.7583Z",
    stroke: "url(#paint0_linear_689_5160)",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7583 51.684V58.1752H73.0388C73.0388 58.1752 75.6328 58.9765 75.6328 61.7508C75.6328 64.5251 73.0388 65.0954 73.0388 65.0954H68.7231L63.6878 71.5274L72.2579 80.0543H82.0273L73.4643 71.5274C73.4643 71.5274 82.0273 69.5427 82.0273 61.7508C82.0273 53.959 75.2653 51.684 73.0388 51.684H62.7583Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_689_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20V33.8043H41.8626C41.8626 33.8043 47.3791 35.5084 47.3791 41.4082C47.3791 47.308 41.8626 48.5209 41.8626 48.5209H32.6848L21.9767 62.1992L40.2019 80.3327H60.9778L42.7676 62.1992C42.7676 62.1992 60.9778 57.9785 60.9778 41.4082C60.9778 24.838 46.5975 20 41.8626 20H20Z",
    stroke: "url(#paint1_linear_689_5160)",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V33.8043H41.8626C41.8626 33.8043 47.3791 35.5084 47.3791 41.4082C47.3791 47.308 41.8626 48.5209 41.8626 48.5209H32.6848L21.9767 62.1992L40.2019 80.3327H60.9778L42.7676 62.1992C42.7676 62.1992 60.9778 57.9785 60.9778 41.4082C60.9778 24.838 46.5975 20 41.8626 20H20Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_689_5160",
    x: 42.7583,
    y: 31.684,
    width: 59.2692,
    height: 68.3703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_689_5160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_689_5160",
    x: 0,
    y: 0,
    width: 80.9779,
    height: 100.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_689_5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_689_5160",
    x1: 62.7583,
    y1: 65.8691,
    x2: 81.995,
    y2: 65.8691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C72FF",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_689_5160",
    x1: 20,
    y1: 50.1663,
    x2: 60.9714,
    y2: 50.1663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF94EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF94EE",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/loginLogo.55c15b1df80488f741a9e38ee04b13ee.svg";
export { ForwardRef as ReactComponent };